import type { RequestConfig } from '@customTypes/index';
import type { ClubFullProfileInfoDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ShowFullClubProfileRequest = {
  profileId: string;
};

export type FullClubProfileParams = RequestConfig<ShowFullClubProfileRequest>;

export const showFullClubProfile = async ({
  params,
  config
}: FullClubProfileParams) =>
  api.get<ClubFullProfileInfoDto>(
    `/api/ClubProfile/full-profile/${params.profileId}`,
    config
  );
